export default __webpack_public_path__ + "static/media/about_bg.d852774c.jpg";